import { isFeedbackTokenShape } from '@portal/contracts'
import { useQuery } from '@tanstack/react-query'
import { getFeedbackContext, isRefusal } from '../api/feedback'
import { feedbackContextKey } from './queryClient'

/**
 * What a rating link authorizes the reader to know about the answer, fetched once per link.
 * A string not shaped like a token is never sent; a refusal is never retried.
 */
export function useFeedbackContext(token: string) {
  return useQuery({
    queryKey: feedbackContextKey(token),
    queryFn: () => getFeedbackContext(token),
    enabled: isFeedbackTokenShape(token),
    retry: feedbackContextRetry,
    staleTime: Number.POSITIVE_INFINITY
  })
}

/** Retry a failure twice, never a refusal: a bad link, a refused body and a busy relay answer the same again. */
export function feedbackContextRetry(failureCount: number, err: unknown): boolean {
  return !isRefusal(err) && failureCount < 2
}
